// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemModeSetting.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * System Mode Setting component
 */
!(function () {
  require('share/utils/Izenda.StringUtilities');
  var React = require('react');
  var classnames = require('classnames');
  var connect = require('share/enhancers/Izenda.Connect');

  var settingConstant = require('logic/data/Izenda.SettingConstants');
  var action = require('./Izenda.SystemModeSettingActions');
  var Panel = require('share/components/controls/Izenda.Panel');
  var Input = require('share/components/controls/Izenda.Input');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');

  var SystemModeSetting = React.createClass({

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    render: function () {
      var props = this.props;
      var store = props.store;
      var systemModeSetting = store.systemModeSetting;
      var localization = props.localization;

      return (
        <Panel header={localization.getText("LICENSE_CHECKER_SYSTEM_MODE_DESCRIPTION")}
               className='panel-default izenda-LicenseInfo'>
          {renderSystemSettingMode()}
        </Panel>
      );


      function renderSystemSettingMode() {
        return (
          <GridLayout className="u-bgWhite u_paddingAll">
            <GridLayout.Row>
              <GridLayout.Col cols={2}>
                <span className="u_controlHeight">{localization.getText('LICENSE_CHECKER_LABEL_SYSTEM_MODE')}</span>
              </GridLayout.Col>
              <GridLayout.Col cols={10}>
                <Input type='radio'
                       checked={systemModeSetting.isSingleMode}
                       onChange={props.swithToSingleTenant}
                       value={settingConstant.SYSTEM_MODE} />
                <span className='u_marginLeftInnerSpace'>{localization.getText('LICENSE_CHECKER_LABEL_SINGLE_TENANT')}</span> &nbsp;
                <Input type='radio'
                       checked={!systemModeSetting.isSingleMode}
                       onChange={props.switchToMultiTenant}
                       value={settingConstant.TENANT_MODE} />
                   <span className='u_marginLeftInnerSpace'>{localization.getText('LICENSE_CHECKER_LABEL_MULTI_TENANT')}</span>
              </GridLayout.Col>
            </GridLayout.Row>
            {!systemModeSetting.isSingleMode && renderUserIDProperties()}
          </GridLayout>
        );
      }

      function renderUserIDProperties() {
        return (
          <GridLayout.Row>
            <GridLayout.Col cols={2}>
              <span className="u_controlHeight">{localization.getText('LICENSE_CHECKER_LABEL_USER_ID_PROPERTIES')}</span>
            </GridLayout.Col>
            <GridLayout.Col cols={10}>
              <Input type='checkbox'
                     onChange={props.changeAllowDuplicate}
                     checked={systemModeSetting.allowDuplicateUser} />
              <span className='u_marginLeftInnerSpace'>{localization.getText('LICENSE_CHECKER_LABEL_ALLOW_DUPLICATE_USER')}</span>
            </GridLayout.Col>
          </GridLayout.Row>
        );
      }
    },
  });



  module.exports = connect(action)(SystemModeSetting);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/LicenseChecker/Izenda.SystemModeSetting.jsx